import { render, staticRenderFns } from "./ReportChatlog.vue?vue&type=template&id=41f00698&"
import script from "./ReportChatlog.vue?vue&type=script&lang=js&"
export * from "./ReportChatlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports